import { render, staticRenderFns } from "./SendTicketForm.vue?vue&type=template&id=1c5abffa"
import script from "./SendTicketForm.vue?vue&type=script&lang=ts"
export * from "./SendTicketForm.vue?vue&type=script&lang=ts"
import style0 from "./SendTicketForm.vue?vue&type=style&index=0&id=1c5abffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports